
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"JobBatchAttributes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"JobBatch"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_jobs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending_jobs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"processed_jobs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"failed_jobs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"progress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"options"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"created_at"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":167}};
    doc.loc.source = {"body":"fragment JobBatchAttributes on JobBatch {\n    id\n    name\n    total_jobs\n    pending_jobs\n    processed_jobs\n    failed_jobs\n    progress\n    options\n    created_at\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
